import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  SimpleChanges,
  ViewChild,
  computed,
  effect,
  inject,
  signal,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSliderModule } from '@angular/material/slider';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SliderangeComponent } from '@shared/components/sliderange/sliderange.component';
import { WINDOW } from '../../search-result.module';
import { SearchResultUiService } from '../../services/search-result-ui.service';
import { CommentsFilterComponent } from '../filters/comments-filter/comments-filter.component';
import { LabelsFilterComponent } from '../filters/labels-filter/labels-filter.component';
import { PriceFilterComponent } from '../filters/price-filter/price-filter.component';
import { ResidenceFilterComponent } from '../filters/residence-filter/residence-filter.component';
import { StarsFilterComponent } from '../filters/stars-filter/stars-filter.component';
import { PlpMapComponent } from '../plp-map/plp-map.component';
import { WebengageService } from '@core/services/webengage.service';
import { TypeOfLocationComponent } from '../filters/type-of-location/type-of-location.component';
import { AccommodationFacilitiesComponent } from '../filters/accommodation-facilities/accommodation-facilities.component';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { Subscription } from 'rxjs';
import { LoadingComponent } from "../../../../shared/components/loading/loading.component";
import { SkeletonComponent } from '@shared/components/skeleton/skeleton.component';
import { RulesFilterComponent } from '../filters/rules-filter/rules-filter.component';

@Component({
  selector: 'iho-filters-sidebar-desktop',
  templateUrl: './filters-sidebar-desktop.component.html',
  styleUrls: ['./filters-sidebar-desktop.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatExpansionModule,
    MatRippleModule,
    MatButtonModule,
    MatCheckboxModule,
    MatSliderModule,
    LabelsFilterComponent,
    TypeOfLocationComponent,
    AccommodationFacilitiesComponent,
    StarsFilterComponent,
    PriceFilterComponent,
    CommentsFilterComponent,
    ResidenceFilterComponent,
    PlpMapComponent,
    SkeletonComponent,
    SliderangeComponent,
    LoadingComponent,
    RulesFilterComponent
],
})
export class FiltersSidebarDesktopComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  constructor(
    @Inject(WINDOW) private window: Window,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    private webengageService: WebengageService
  ) {
    effect(() => {
      if (this.searchBoxService.isSearch() || !this.searchBoxService.isSearch()) {
        this.Filters = [];
      }
    });
  }
  @Input() mapUrlMain?: string;
  private _dataSource: any[] = [];

  @Input() set dataSource(value: any[]) {
    const order = ['labels', 'price', 'grades', 'reviews', 'types', 'rules' , 'facilities' ];
    // sort the dataSource array based on the order array
    this._dataSource = [...(value || [])].sort((a:any, b:any) => {
      const indexA = order.indexOf(a.Key);
      const indexB = order.indexOf(b.Key);
      return indexA - indexB;
    });
  }

  get dataSource(): any[] {
    return this._dataSource;
  }
  
  @Output() removeDesktopFilters = new EventEmitter();
  @ViewChild('filtersSidebar') scrollContainer!: ElementRef;

  private searchBoxService = inject(SearchBoxService);
  showPriceFilter = signal(true);
  expanded = signal(true);
  reviews = [];
  grades = [];
  types = [];
  labels = [];
  minPrice = '';
  maxPrice = '';
  location = [];
  facilities = [];
  rules = [];
  route = inject(ActivatedRoute);
  router = inject(Router);
  searchUiService = inject(SearchResultUiService);
  queryParams = {};
  isFiltersSet = signal(false);
  scrollPosition = 0;
  showFilterComponents = signal(true);
  itemsPush: any = [];
  accommodation = computed(() => this.searchBoxService.accommodation());
  //flagScroll: boolean = false;
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dataSource']?.currentValue?.length) {
      if (isPlatformBrowser(this.platformId)) {
        setTimeout(() => {
          if (!this.Filters.length) {
            this.scrollContainer.nativeElement.scrollTo({
              top: 0,
              left: 0,
              behavior: 'smooth'
            });
          } else {
            this.restoreScrollPosition();

          }
         // this.flagScroll = false;

        }, 2000);
      }

    }
    this.minPriceFilterInit = +this.route.snapshot.queryParams['minPrice'];
    this.maxPriceFilterInit = +this.route.snapshot.queryParams['maxPrice'];
  }
  restoreScrollPosition(): void {
    const savedPosition = localStorage.getItem('scrollPosition');
    if (savedPosition) {
      this.scrollContainer.nativeElement.scrollTo({
        top: +savedPosition,
        left: 0,
        behavior: 'smooth'
      });

    }

  }

  filterLabels: string[] = ['reviews', 'grades', 'types', 'labels', 'minPrice', 'maxPrice', 'rules','facilities'];
  filterLabelsEcologe: string[] = [
    'labelsAccomodate',
    'facilities',
    'hotelStyles',
    'hotelTypes',
    'minPrice',
    'maxPrice',
  ];

  filters: any = {
    reviews: false,
    grades: false,
    types: false,
    labels: false,
    minPrice: false,
    maxPrice: false,
    rules: false,
    facilities: false,
  };
  filtersEcologe: any = {
    labelsAccomodate: false,
    hotelTypes: false,
    hotelStyles: false,
    facilities: false,
    minPrice: false,
    maxPrice: false,
  };

  minPriceFilterInit!: number | string | undefined;
  maxPriceFilterInit!: number | string | undefined;

  Filters: string[] = [];
  ngAfterViewInit() {
   // this.scrollContainer?.nativeElement?.addEventListener('scroll', this.saveScrollPosition.bind(this)); 
  }
  ngOnInit(): void {
    this.checkRouteFilters();
    
  }

  MinValue(ev: any) {
    this.minPrice = ev;
    this.getDataForFilters(ev, 'minPrice');
  }

  MaxValue(ev: any) {
    this.maxPrice = ev;
    this.getDataForFilters(ev, 'maxPrice');
  }

  checkRouteFilters() {
    const params = this.route.snapshot.queryParams;
    this.Filters = [];

    Object.entries(params).forEach((param: any) => {
      if (this.accommodation() == 'ecolodge') {
        this.filterLabelsEcologe.forEach((label) => {
          if (param[0] == label && param[1].length) this.Filters.push(param[0]);
        });
      } else {
        this.filterLabels.forEach((label) => {
          if (param[0] == label && param[1].length) this.Filters.push(param[0]);
        });
      }
    });
    if (!this.Filters.length) {
      this.resetFilterComponentsUi();
    }
  }

  removeAllFilters(e: Event | string) {
    this.searchUiService.resetPlpResults();
    if (e instanceof Event) e.stopPropagation();
    this.minPriceFilterInit = undefined;
    this.maxPriceFilterInit = undefined;
    this.removeDesktopFilters.emit();
    this.resetFilterComponentsUi();
  }

  resetFilterComponentsUi() {
    this.Filters = [];
    this.expanded.set(false);
    this.showFilterComponents.set(false);

    if (isPlatformBrowser(this.platformId))
      setTimeout(() => {
        this.showFilterComponents.set(true);
        this.expanded.set(true);
        this.minPriceFilterInit = undefined;
        this.maxPriceFilterInit = undefined;
      }, 500);
  }

  getDataForFilters(val: any, typeFilter: string) {
    this.webengageService.trackIntrack('Select-Filter', {
      maxPrice: this.minPrice,
      minPrice: this.maxPrice,
      starRating: this.grades.join(',').toString(),
      review: this.reviews.join(',').toString(),
      accommodationType: this.types,
      destination: this.searchUiService.cityName,
      labels: this.labels,
    });

    this.queryParams = this.route.snapshot.queryParams;


    this.searchUiService.isFilterSet.update((_) => _ + 1);

    this.searchUiService.resetPlpResults();
    this.router
      .navigate([], {
        queryParams: {
          ...this.queryParams,
          page: 1,
          [typeFilter]: val.toString(),
        },
        relativeTo: this.route,
        queryParamsHandling: 'merge',
      })
      .finally(() => {
        this.checkRouteFilters();
      });
  }

  checkedItemsEmit(obj: any) {
   // this.flagScroll = true;
    switch (obj.key) {
      case 'types':
        this.types = obj.value;
        this.getDataForFilters(obj.value, this.accommodation() == 'ecolodge' ? 'hotelTypes' : 'types');
        break;
      case 'hotelStyles':
        this.location = obj.value;
        this.getDataForFilters(obj.value, 'hotelStyles');
        break;
      case 'labels':
        this.labels = obj.value;
        this.getDataForFilters(
          obj.value,
          this.accommodation() == 'ecolodge' ? 'labelsAccomodate' : 'labels'
        );
        break;
      case 'reviews':
        this.reviews = obj.value;
        this.getDataForFilters(obj.value, 'reviews');
        break;
      case 'grades':
        this.grades = obj.value;
        this.getDataForFilters(obj.value, 'grades');
        break;
      case 'facilities':
        this.facilities = obj.value;
        this.getDataForFilters(obj.value, 'facilities');
        break;
      case 'rules':
        this.rules = obj.value;
        this.getDataForFilters(obj.value, 'rules');
          break;
    }
  }
  ngOnDestroy(): void {
  }
}
